<template>
  <Grid gtc="auto 1fr" gap="var(--r-space-sm)" align-items="start" class="text-secondary-1">
    <span class="dot" :style="{ backgroundColor: color }"></span>
    <Grid>
      <span class="text-caption-3">{{ title }}</span>
      <span class="text-body-3">{{ amount }} {{ type }}</span>
    </Grid>
  </Grid>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      required: true
    },

    title: {
      type: String,
      required: true
    },

    amount: {
      type: Number,
      required: true
    },

    type: {
      type: String,
      default: 'subscriptions'
    }
  }
}
</script>

<style lang="scss" scoped>
.dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-top: 5px;
}
</style>
